import React,{ Component } from 'react';
import { connect } from 'react-redux';
import {withTranslation} from 'react-i18next';
import { withRouter } from 'react-router';
import * as actions from '../../store/actions'
import Wrp from "../../hoc/Wrp/Wrp";
import { callGET, callPOST, callPUT, callDELETE } from '../../Utils/ApiUtil';
import * as ShipConstants from '../../Global/Constants';
import BreadCrumbs from "../../Components/UI/BreadCrumbs";
import TableRecord from "../../Components/UI/TableRecord";
import CreateNew from "./CreateNew";
import {findFiltersOjectByFilterIdAndFilterArray, findFiltersByFieldIdWithFieldArr, prepareOptionArr, findArrayIndex} from '../../Utils/CommonFunctions';
import { getCurrentModuleId } from '../../Utils/UserFunctions';
// import AutomationProgress from "./AutomationProgress";
// import { v4 as uuidv4 } from 'uuid';
import { v4 as uuidv4 } from 'uuid';
const AutomationProgress = React.lazy(() => import('./AutomationProgress'));

const OPERATION_TYPE = [{
                "name": "Web Automation",
                "value": "WEB_AUTOMATION",
                "label": "Web Automation"
              }];


class AutomationContainer extends Component {
	
	state = {
		isCreateNewModelOpen:false,
		isAutomationProgressModelOpen:false,
		progressMsg:null,
		windowsList: [],
		windowFields: [],
		fieldGroups : null,
		relatedWindowFields:null,
		window_info : {
      window_id : '',
      window_name : '',
      related_window : [],
      relatedSelWindow : []
    },
    executeResults : {
      processId:'',
      statusCode:0,
      results:[],
      message:""
    },
		addFormFields: {
			id:null,
			operation_name : {
						name : "operation_name",
	          field : "text",
	          required : true,
	          title : 'Operation Name',
	          placeHolder : "",
	          value : '',
	          classname : 'form-control mandatory',
	          error: '',
	          options : []
	        },
	        operation_type : {
	        	name : "operation_type",
	          field : "select2",
	          required : true,
	          title : 'Operation Type',
	          placeHolder : "",
	          value : '',
	          classname : 'form-control',
	          error: '',
	          options : OPERATION_TYPE
	        },
	        window_type : {
	        	name : "window_type",
	          field : "select2",
	          required : true,
	          title : 'Window Type',
	          placeHolder : "",
	          value : '',
	          classname : 'form-control',
	          error: '',
	          options : []
	        },
	        description : {
	        	name : "description",
	          field : "textarea",
	          required : true,
	          title : 'Description',
	          placeHolder : "",
	          value : '',
	          classname : 'form-control',
	          error: '',
	          options : []
	        },
	        status : {
	        	name : "status",
	        	id:"status",
	          field : "status",
	          required : true,
	          title : 'Status',
	          placeHolder : "",
	          value : '',
	          classname : 'form-control',
	          error: '',
	          options : []
	        },
          window_data : {
            name : "window_data",
            placeHolder : "",
            value : '',
            classname : 'form-control',
            error: '',
            options : []
          },
	        filters : [/*{
                tableDescriptorId: "",
                fieldFilterId: "",
                fieldFilter: [],
                values: [],
                lineNumber: 1,
                logicalOperator: "0",
                filterObject: null,
                fieldType: '',
                fieldTypeId : '',
                multiSelectOptions : [],
                lookupWindowName : '',
                lookupWindowNameId : '',
                absolute_window : '',
                absolute_window1: ''
            }*/]     
		},
		tableRecords:{
          tableHead:[
            {
              name:"Action",
              type:"Actions",
              href:"",
              isShow:true,
              clickHandler:"",
              attributes:{
                style:{width: "75px"}
              }
            },{
              name:"Operation Name ",
              type:"Setting",
              clickHandler:"",
              isShow:true,
              attributes:{ }
            },
            {
              name:"Operation Type ",
              type:"Text",
              clickHandler:"",
              isShow:true,
              attributes:{ }
            },
            {
              name:"Description",
              type:"Text",
              clickHandler:"",
              isShow:true,
              attributes:{ }
            },
            {
              name:"Is Active",
              type:"Status",
              clickHandler:"",
              isShow:true,
              attributes:{ }
            },
            {
              name:"Window Type",
              type:"Text",
              clickHandler:"",
              isShow:true,
              attributes:{ }
            },
            {
              name:"Filtered By",
              type:"Text",
              clickHandler:"",
              isShow:true,
              attributes:{ }
            },
          ],
          tableData:[], 
          pagination:{
            page:0,
            orderBy:'',
            perPage:10,
            direction:'ASC',
            totalRecords:0,
            search:''
          }
        }
	}

	componentWillMount = () => {
		this.automationList(this.state.tableRecords.pagination);
		// this.windowsList();
		this.generateWindowFields();
	}

  componentDidMount(){
    this.timerForexecutionResults = setInterval(
      () => {
        const {executeResults} = this.state;
        const {processId,statusCode} = executeResults;
        if(processId !== "" && statusCode === "100 CONTINUE"){
          console.log(executeResults); 
          this.getExecuteResults(processId);
        }
      },1000
    );
  }

  componentWillUnmount(){
      clearInterval(this.timerForexecutionResults);
  }
	render() {
		const breadCrumbs =   this.getAndSetBreadCrumbs();
		// const {tableRecords} = this.state;
		const {automationList,toogleCreateNewHandler,addFilters,deleteFitler,valueChangeHandler,filtersChangeHandler,
			filterDrillDownChangeHandler,saveHandler,windowInfoChangeHandler,addTopFilter} = this;

		return (
			<Wrp>
	          <BreadCrumbs breadCrumbsList={breadCrumbs} />
        	  <div className="viewport">
	          	<div className="view view-xl">
            	  <div className="outerPort">
		               
	              	<TableRecord 
	                  tableRecords={this.state.tableRecords} 
	                  recordsChangeHandler={automationList}
                	/>
		              
	              </div>
	          	</div>
	          </div>

      		  {/*Create New Automation Popup*/}
	          <CreateNew
              {...this.props}
              {...this.state}
              valueChangeHandler={valueChangeHandler}
              toggleModel={toogleCreateNewHandler}
              addFilters={addFilters}
              deleteFitler={deleteFitler}
              filtersChangeHandler={filtersChangeHandler}
              filterDrillDownChangeHandler={filterDrillDownChangeHandler}
              saveHandler={saveHandler}
              windowInfoChangeHandler={windowInfoChangeHandler}
              addTopFilter={addTopFilter}
            />
	          <AutomationProgress
	          	{...this.props}
              {...this.state}
              toggleModel={this.toggleProgressModel}
	          />
	      	</Wrp>
		)
	}

	toggleProgressModel = () => {
		this.setState({
    	isAutomationProgressModelOpen:!this.state.isAutomationProgressModelOpen,
      executeResults : {
        processId:'',
        statusCode:0,
        results:[],
        message:""
      }
    })
	}

	excecuteHandler = (processIData) => {
		console.log('processIData',processIData);
    // console.log(uuidv4()); return false;
		this.props.Loader();
		const msg = [{
        			    "Step1" :   "OPEN BROWSER :  Execute Successfully",
        			    "Step2" :   "${Carrier.username} = jiit@123  =>  Input Password : Executed Successfully",
        			    "Step3" :   "Password Text Box Not Identified",
        				 },{
							    "Step11" :   "OPEN BROWSER 1:  Execute Successfully",
							    "Step22" :   "${Carrier.username} = jiit@123  =>  Input Password : Executed Successfully",
							    "Step33" :   "Password Text Box Not Identified",
								 }];
    this.setState({
    	isAutomationProgressModelOpen:true,
    	// progressMsg:msg,
      executeResults : {
        processId:'',
        statusCode:0,
        results:[],
        message:""
      }
    })
    const uuid1 = uuidv4();
		const body = {
      automation_id:processIData.id,
      transaction_id:uuid1
    }
		callPOST("automations-process/execute",body)
      .then(response => {
      	const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.getExecuteResults(processIData.id,uuid1);
          this.setState({
            isAutomationProgressModelOpen:true,
            // progressMsg:msg
          })
        }
        this.props.Loader(false);
      })
      .catch(err => {
        this.props.Loader(false);
        console.log("error occured",err);
      });
	}

	getExecuteResults = (processID,uuid="") => {
		let URL = "automations-process/result/"+processID+"/"+uuid;
		callGET(URL)
      .then(response => {
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          const updateState = {...this.state}
          updateState.executeResults.statusCode = responseData.data.status_code;
          updateState.executeResults.message = responseData.data.message;
          updateState.executeResults.results = responseData.data.results;
          updateState.executeResults.processId = processID;
          this.setState(updateState);
        }
      })
      .catch(err => {
        console.log("error occured",err);
      });
	}

	generateWindowFields = (isEdit=false) => {
    const params = this.props.match.params;
    const moduleId = getCurrentModuleId();
    let URL = "field-groups/window/related-windows";
    callGET(URL)
      .then(response => {
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
          const fieldGroups = responseData.data;
          const windId = fieldGroups[0].window_id;
          const relWind = fieldGroups[0].related_window;
          const updateState = {...this.state};
          updateState.fieldGroups = fieldGroups;
          if(!isEdit) {
            updateState.window_info["window_id"] = windId;
            updateState.window_info["related_window"] = relWind;
          }
          
          this.setState(updateState);
        }
      })
      .catch(err => {
        console.log("error occured",err);
      });
  }

  windowInfoChangeHandler = (name, value, table_descriptor_id) => {
    const updateState = {...this.state};
    let relWind = [];
    if(name === 'related_window') {
      relWind = this.state.window_info.relatedSelWindow;
      const inda = findArrayIndex(table_descriptor_id,relWind)
      if(findArrayIndex(table_descriptor_id,relWind) === -1) {
        relWind.push({window_id:value,table_descriptor_id:table_descriptor_id})
      }else {
        const ind = findArrayIndex(table_descriptor_id,relWind);
        relWind.splice(ind,1);
      }
      updateState.window_info['relatedSelWindow'] = relWind;
    }else {
      relWind = this.getRelatedWindowFromFieldGroups(value);
      updateState.window_info[name] = value;  
      updateState.window_info['related_window'] = relWind;
      updateState.window_info['relatedSelWindow'] = [];

      updateState.addFormFields["window_data"].error = "";

    }
    this.setState(updateState);

    setTimeout(() => {
      this.addTopFilter(true);
    }, 200);
  }

  getRelatedWindowFromFieldGroups = (windowId) => {
    const fieldGroups = this.state.fieldGroups;
    let relatedWindow = [];
    fieldGroups.map((arr,i) => {
      if(windowId === arr.window_id) {
        relatedWindow = arr.related_window;
      }
    });
    return relatedWindow;
  }

	addTopFilter = (isWindowChanged=false) => {
    
    if(isWindowChanged === false) {
      const updateState = {...this.state};
      updateState.addFormFields.filters.push({
              tableDescriptorId: "",
              fieldFilterId: "",
              fieldFilter: [],
              values: [],
              lineNumber: 1,
              logicalOperator: "0",
              filterObject: null,
              fieldType: '',
              fieldTypeId : '',
              multiSelectOptions : [],
              lookupWindowName : '',
              lookupWindowNameId : '',
              absolute_window : '',
              absolute_window1 : ''
          });
      this.setState(updateState);

      return false;
    }
		const windowInfo = this.state.window_info;
    const thisObj = this;
    let relWind = [];
    this.props.Loader();
    if(windowInfo.relatedSelWindow) {
      windowInfo.relatedSelWindow.map((arr,i) => {
        relWind.push(arr);
      })
    }
    const body = {
      window_info : {
        window_id : windowInfo.window_id,
        related_window : relWind
      }
    }
    callPOST("field-groups/window/related-windows/fields",body)
      .then(response => {
        this.props.Loader();
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
        	const addRow =  {
			        tableDescriptorId: "",
			        fieldFilterId: "",
			        fieldFilter: [],
			        values: [],
			        lineNumber: 1,
			        logicalOperator: "0",
			        filterObject: null,
			        fieldType: '',
			        fieldTypeId : '',
			        multiSelectOptions : [],
			        lookupWindowName : '',
			        lookupWindowNameId : '',
			        absolute_window : '',
			        absolute_window1 : ''
			    }

          const updateState = {...this.state};
          updateState.relatedWindowFields = responseData.data;
          if(isWindowChanged === false) {
            updateState.addFormFields.filters.push(addRow);
          }else {
            updateState.addFormFields.filters = [];
          }
			    this.setState(updateState);

        }
      })
      .catch(err => {
        this.props.Loader(false);
        console.log("error occured",err);
      });
	}

	// delete action button permanently   
  deleteAutomationProcess = (deleteID) => {
      this.props.Loader();
      callDELETE('automations-process/'+deleteID+'/delete')
          .then((response) => {
              this.props.Loader();
              const responseData = response.data;
              if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {                                            
                  this.props.succMessage(responseData.message);
                  this.automationList(this.state.tableRecords.pagination);
              }else {                    
                  this.props.failMessage(responseData.message);
              }                    
          }, (error) => {
              this.props.Loader();
              this.props.failMessage('Error occured while delete action button');
              console.log(error);
          });
  }

  findFilterObjByFilterId = (id,windArr) => {
    let obj = {};
    // const windowFields = this.state.reportPreviewFields.window_fields;
    const windowFields = windArr;
    Object.keys(windowFields).map(function(key) {
        windowFields[key].map((windArr,windInd) => {
          if(windArr.id === id) {
            obj=windArr;
          }
        })
    })
    return obj;
  }

	editHandler = (data) => {
		this.props.Loader();
		const thisObj = this;
		const body = {
      window_info : {
        window_id : data.window_id,
        related_window : data.related_windows
      }
    }
		//callGET('field-groups/window/'+data.window_id+'/lookup-layouts')
		callPOST('field-groups/window/related-windows/fields',body)
  		.then(windowResponse => {
				const windowFields = windowResponse.data.data;

    		const updateState = {...this.state};
    		const relWind = this.getRelatedWindowFromFieldGroups(data.window_id);

    		updateState.relatedWindowFields = windowResponse.data.data;
    		updateState.window_info.window_id = data.window_id;
    		updateState.window_info.related_window = relWind;
    		updateState.window_info.relatedSelWindow = data.related_windows;

    		// updateState.windowFields = windowFields;  
				updateState.addFormFields.operation_name.value = data.name;
				updateState.addFormFields.operation_type.value = data.automation_type;
				// updateState.addFormFields.window_type.value = data.window_id;
				updateState.addFormFields.description.value = data.description;
				updateState.addFormFields.status.value = data.active;
				updateState.addFormFields.id = data.id;

				
				if(data.filters) {
					// const fieldFilter = windowFields.fields_with_filters && windowFields.fields_with_filters.window_fields ? windowFields.fields_with_filters.window_fields : [];
					// const fieldWithFilters= windowFields.fields_with_filters;

					data.filters.forEach(function(filterData) {
						//const data = findFiltersByFieldIdWithFieldArr(filterData.tableDescriptorId, fieldFilter, fieldWithFilters);
						const data = thisObj.findFilterObjByFilterId(filterData.tableDescriptorId, windowFields.window_fields);
						filterData.fieldFilter = data.filters;
						const data1 = findFiltersOjectByFilterIdAndFilterArray(filterData.fieldFilterId, data.filters);
						filterData.filterObject = data1;
						const multiSelectOptions = data.options;
						filterData.multiSelectOptions = prepareOptionArr(multiSelectOptions);
						filterData.fieldType = filterData.field_type_name;
						let lookupField = [];
		        if(filterData.absolute_display && filterData.absolute_display !== '') {
		        	let res = filterData.absolute_display.split(".");
		        	if(res.length > 0) {
		                res.map((arr1,ind) => {
		                    lookupField.push({field_name :arr1});
		                })
		            }
		        }
		        lookupField.push({field_name :filterData.display_name});
		        filterData.absolute_window1 = lookupField;
		        if(filterData.values) {
		        	filterData.values.map((item,iind) => {
		        		item.text = item.label;
		        		item.id = item.value;
		        	})
		        }
		        filterData.lookupWindowName = filterData.lookup_window_name;
		        if(filterData.dependent_layout) {
							filterData.lookupWindowNameId = filterData.dependent_layout.window_id;
						}

						/*if(filterData.fieldType === 'Email') {
		            filterData.lookupWindowName = "Email";
		            filterData.lookupWindowNameId = ShipConstants.EMAIL_WINDOW_ID;
		        }*/

		        if(filterData.fieldType && filterData.fieldType.toLowerCase() === 'notes') {
		            filterData.lookupWindowName = filterData.windowName;
		            filterData.lookupWindowNameId = filterData.windowId;
		            filterData.isNotes=true;
		        }

		        if(filterData.dependent_layout && filterData.dependent_layout.window_id === ShipConstants.NOTES_WINDOW_ID) {
		        		filterData.lookupWindowName = filterData.windowName;
		            filterData.lookupWindowNameId = filterData.windowId;
		            filterData.isNotes=true;
		        }

		        if(filterData.fieldType === 'User') {
		            filterData.lookupWindowName = "User";
		            filterData.lookupWindowNameId = ShipConstants.USERS_WINDOW_FIELD_ID;
		        }

					});
					updateState.addFormFields.filters = data.filters;
				}
				updateState.isCreateNewModelOpen = true;
				this.setState(updateState);
				this.props.Loader(false);
  		})
		
	}

	saveHandler = () => {
		const {Loader,succMessage,failMessage,history} = this.props;
		const {operation_name,operation_type,window_type,description,filters,id,status} = this.state.addFormFields;
		const windowInfo = this.state.window_info;

		let filterArr=[];
		if(filters) {
			filters.map((item,ind) => {
				if(item.tableDescriptorId !== '') {
            item.line_number=ind+1;
            filterArr.push(item);
        }
			})
		}

		let relWind = [];
    if(windowInfo.relatedSelWindow) {
      windowInfo.relatedSelWindow.map((arr,i) => {
        relWind.push(arr);
      })
    }

		const body = {
			id:id,
			name:operation_name.value,
			description:description.value,
			automation_type:operation_type.value,
			window_id:windowInfo.window_id,
			filters:filterArr,
			is_active:status.value,
			related_windows:relWind
		}
		Loader();
		if(id && id!=='') {
			callPOST("automations-process/save",body)
	    .then(response => {
	      Loader(false);
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.toogleCreateNewHandler();
	        succMessage(responseData.message);
	        this.automationList(this.state.tableRecords.pagination);
	      }else if(responseData.code === ShipConstants.API_STATUS_FAIL) {
	        if(responseData.violations.length > 0) {
	        	const updateState = {...this.state};
	          responseData.violations.map(arr => {
	          	if(arr.field_name === 'name') {
	          		updateState.addFormFields['operation_name'].error= arr.message;	
	          	}else if(arr.field_name === 'automation_type') {
                updateState.addFormFields['operation_type'].error= arr.message; 
              }else if(arr.field_name === 'window_id') {
                updateState.addFormFields['window_data'].error= arr.message; 
              }
	          })
	          this.setState(updateState);
	        }
	        this.props.failMessage(responseData.message);
	      }else {
      		failMessage(responseData.message/*+"<br/>"+errMsg*/);
      	}
    	})
	    .catch(err => {
	      Loader(false);
	      failMessage("Error occured");
	      console.log(err);
	    })
		}else {
			callPOST("automations-process/save",body)
	    .then(response => {
	      Loader(false);
	      const responseData = response.data;
	      if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	        this.toogleCreateNewHandler();
	        succMessage(responseData.message);
	        this.automationList(this.state.tableRecords.pagination);
	      }else if(responseData.code === ShipConstants.API_STATUS_FAIL) {
	        if(responseData.violations.length > 0) {
	        	const updateState = {...this.state};
	          responseData.violations.map(arr => {
	          	if(arr.field_name === 'name') {
	          		updateState.addFormFields['operation_name'].error= arr.message;	
	          	}else if(arr.field_name === 'automation_type') {
                updateState.addFormFields['operation_type'].error= arr.message; 
              }else if(arr.field_name === 'window_id') {
                updateState.addFormFields['window_data'].error= arr.message; 
              }
	          })
	          this.setState(updateState);
	        }
	      }else {
      		failMessage(responseData.message/*+"<br/>"+errMsg*/);
      	}
    	})
	    .catch(err => {
	      Loader(false);
	      failMessage("Error occured");
	      console.log(err);
	    })
		}
		
	}

	filterDrillDownChangeHandler = (value,index) => {
		const updateState = {...this.state};
		updateState.addFormFields.filters[index] = value;
		this.setState(updateState);
	}

	filtersChangeHandler = (name,value,index) => {
		const updateState = {...this.state};
		updateState.addFormFields.filters[index][name] = value;
		this.setState(updateState);
	}

	valueChangeHandler = (value,name) => {
		const updateState = {...this.state};
		updateState.addFormFields[name].value = value;
		updateState.addFormFields[name].error = "";
		this.setState(updateState);
		if(name === "window_type") {
			this.getWindowFields(value);
		}
	}

	addFilters = () => {
		const updateState = { ...this.state };
        const addRow =  {
            tableDescriptorId: "",
            fieldFilterId: "",
            fieldFilter: [],
            values: [],
            lineNumber: 1,
            logicalOperator: "and",
            filterObject: null,
            fieldType: '',
            fieldTypeId : '',
            multiSelectOptions : [],
            lookupWindowName : '',
            lookupWindowNameId : '',
            absolute_window : '',
            absolute_window1 : ''
        }
        updateState.addFormFields.filters.push(addRow); 
        this.setState(updateState);
	}

	deleteFitler = (index) => {
		const updateState = { ...this.state };
    updateState.addFormFields.filters.splice(index, 1); 
    this.setState(updateState);
	}

	automationList = (pagination) => {
		const {Loader} = this.props;
		const page = pagination.page; 
    const orderBy = pagination.orderBy; 
    const perPage = pagination.perPage; 
    const direction = pagination.direction; 
    const search = pagination.search;
    this.setState({
      tableRecords:{
        ...this.state.tableRecords,
        pagination:pagination
      }
    })
    Loader();
    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
    callGET("automations-process/search"+queryString)
        .then(response => {
        	Loader(false);
        	if(response.data.code === ShipConstants.API_STATUS_SUCCESS) { 
	          const responseData = response.data.data.content;
	          let updateTableData = responseData.map((item,index)=>{
              const id = item.id+'index'+index;
              let dispCont = '';
              if(item.filters.length > 0) {
                  
                  item.filters.map((item,ind) => {
                      dispCont += <span>
                                      { ind !== 0 ? <div className="badge badge-warning p-1 mr-1"> AND  </div> : null }
                                      <div className="text-medium mb-0">{item.display_name} <code> {item.field_filter} </code>
                                          {item.values && item.values.length > 0 ? 
                                              item.values.map(data => {
                                                  return data.label ? data.label : data.value
                                              })
                                           : ''}
                                      </div>
                                  </span>
                  })
              }
	            return {
	              className:'icon_hover cursor-pointer',
	              rowId:"",
	              data:{
	                actions:[
                  {
                    clickHandler:this.editHandler.bind(this,item),
                    attributes:{
                      className:"p-1"
                    },
                    svgIcon:"Edit",
                    name:""
                  },
	                  {
	                    attributes:{
	                      className:"p-1"
	                    },
	                    svgIcon:"Delete",
	                    clickHandler:this.deleteAutomationProcess.bind(this,item.id),
	                    name:""
	                  }
	                  
	                /*{
	                  href:"/automation/"+item.id+"/process-list",
	                  attributes:{
	                    className:"p-1"
	                  },
	                  svgIcon:"PreviewLinesIcon",
	                  name:""
	                }*/
	              ],
	                // name:item.name,
	                name:{
			                  value: item.name,
			                  href:"/automation/"+item.id+"/process-list",
			                  //href:"",
			                  param:{
			                    data:{...item},
			                  },
			                  attributes:{
			                    id: item.id
			                  },
			                  setting:{
		                      attributes:{},
		                      actionMore:[{
	                         	href:"",
	                         	clickHandler:this.excecuteHandler.bind(this,item),
	                          attributes:{
	                            className:"dropdown-item"
	                          },
	                          access_mode:true,
	                          name:"Execute",
		                      }]
		                    }
			            },
	                type:item.automation_type,
	                description:item.description,
	                status:{
	                  checked:item.active,
	                  attributes:{}
	                },
	                window:item.window_name,
	                filterBy:
                   (item.filters.length===0)?<span className="text-small text-danger">No Filters Applied</span>:  
                  	<div className="item-list">
															<div className="btn-group">
														  	<div className="text-info textUnderline cursor-pointer" data-toggle="dropdown" title="Filter List"> {item.filters.length} Filters  
																	<div className="dropdown-menu dropdown-menu-right" style={{"min-width": "250px"}}>
																		<div className="dropdown-item p-1" style={{"white-space": "normal", "word-break": "break-word"}}>
																			<div className="d-flex align-items-center justify-content-center">
																				<div className="text-center">
																				{
																					item.filters.length > 0 ?
																						item.filters.map((item,ind) => {
																							return (
																								<span>
						                                      { ind !== 0 ? <div className="badge badge-warning p-1 mr-1"> {item.logicalOperator}  </div> : null }


						                                      <div className="text-medium mb-0">{item.display_name} <code> {item.field_filter} </code>
						                                          {item.values && item.values.length > 0 ? 
						                                              item.values.map((data,dataind) => {
						                                              		const val = data.label ? data.label : data.value;
						                                                  return dataind === 0 ? val : ','+val
						                                              })
						                                           : ''}
						                                      </div>
						                                  </span>
																							)
																						})
																					: null
																				}
																				</div>
																			</div>
																		</div>
																	</div>
															 	</div>
															</div>
														</div>,
	              }
	            }
	              
	        });
	          const totalRecords = response.data.data.total_elements;
	          this.setState({status:200, tableRecords:{
                tableData:{data:updateTableData,status:200},
                tableHead:this.state.tableRecords.tableHead ,
                pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
            }});
      		}
        })
        .catch(err => {
        	Loader(false);
          const totalRecords = 0;//response.data.totalElements;
          this.setState({status:200, tableRecords:{
            tableData:[],
            tableHead:this.state.tableRecords.tableHead ,
            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
          }});
        });
	}

	toogleCreateNewHandler = () => {
		const updateState = {...this.state};
		updateState.window_info = {
      window_id : '',
      window_name : '',
      related_window : [],
      relatedSelWindow : []
    };
		updateState.addFormFields['operation_name'].value='';
		updateState.addFormFields['operation_type'].value='';
		// updateState.addFormFields['window_type'].value='';
		updateState.addFormFields['description'].value='';
		updateState.addFormFields['status'].value=true;
		updateState.addFormFields['id']=null;
		updateState.addFormFields['filters']=[/*{
                tableDescriptorId: "",
                fieldFilterId: "",
                fieldFilter: [],
                values: [],
                lineNumber: 1,
                logicalOperator: "0",
                filterObject: null,
                fieldType: '',
                fieldTypeId : '',
                multiSelectOptions : [],
                lookupWindowName : '',
                lookupWindowNameId : '',
                absolute_window : '',
                absolute_window1: ''
            }*/];
    updateState.isCreateNewModelOpen = !this.state.isCreateNewModelOpen;
    this.setState(updateState);
		// this.setState({isCreateNewModelOpen:!this.state.isCreateNewModelOpen});
	}

	//Windows List
  windowsList = () => {
  	const {Loader} = this.props;
    const queryString = '?query=&page=0&orderBy=display_name&size=1000&direction=';
    Loader();
    callGET("windows/list/false/true"+queryString)
    .then(res => {
        const response = res.data;
        let windowsList = [];
        if(response.code===200){
          response.data.windows.content.map((arr,i) => {
              if(i===0){
                  this.getWindowFields(arr.id,false);
              }
              const value = {
                "name": arr.display_name,
                "value": arr.id,
                "label": arr.display_name
              }
              windowsList.push(value);
          })
        }
        // this.setState({windowsList:windowsList});

        if(windowsList.length > 0) {
            const updateState = {...this.state};
		        updateState.addFormFields.window_type.value = windowsList[0].value;
		        updateState.addFormFields.window_type.options = windowsList;
		        this.setState(updateState);
        }else {
        	Loader(false);
        }
        
    }, (error) => {
        console.log(error);
        Loader(false);
    });
  }

    getWindowFields = (windowID,isLoad=true) => {
    	const {Loader} = this.props;
      if(windowID!=='' && windowID!==null){
      	if(isLoad === true) { Loader(); }
        callGET('field-groups/window/'+windowID+'/lookup-layouts')
        .then(windowResponse => {
            const responseData = windowResponse.data;
            if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
                this.setState({windowFields:responseData.data});
            }else {
                this.setState({windowFields:[]});
            }
            Loader(false);
        },(error) => {
            this.setState({windowFields:[]});
            Loader(false);
        })
      }
    }

	getAndSetBreadCrumbs = () => {
		return {
	      backHistory : [{
                href : "/settings",
                name:"Settings"
              }],
	      pageTitle:"Automations",
	      buttonList:[{
	        name:"Add New",
	        type:"addNew",
	        clickHandler:this.toogleCreateNewHandler,
	        attributes:{
	          className:"btn primary_bg",
	        }
	      }]
	    }
	}
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (msg) => dispatch(actions.loader(msg)),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))    
  };
}

export default connect(null, mapDispatchToProps)(withRouter(withTranslation()(AutomationContainer)));